import { render, staticRenderFns } from "./TmsPartInfo.vue?vue&type=template&id=1d0460b3"
import script from "./TMSPartInfo.ts?vue&type=script&lang=ts&external"
export * from "./TMSPartInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./TmsPartInfo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports